import styled from 'styled-components';
import { GatsbyImageFluidProps } from 'gatsby-image';
import GatsbyImage from 'gatsby-image/withIEPolyfill';
import { media } from 'src/views/theme';

export const PageHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderAndImage = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 10rem;

  ${ media.md } {
    padding-right: 0;
  }
`;

export const ImageEx = styled(GatsbyImage)<GatsbyImageFluidProps>`
  min-width: 24.4rem;

  ${ media.md } {
    display: none;
  }
`;
